import React from 'react';
import './ProfilePage.less';
import CloseIcon from '../../images/close_icon.png'
import BinIcon from '../../images/bin_icon.png'
import ResetTOTPIcon from '../../images/2FA_Reset_Icon.png'
import AccountIcon from '../../../base/images/account_icon.png';
import Dialog from '../Dialog/Dialog';
import { withTranslation } from 'react-i18next';
import { AdminHandler } from '../AdminHandler/AdminHandler';
import Dropdown from '../Dropdown/Dropdown';
import infoIcon from '../../images/i_icon.png';

class ProfilePage extends React.Component {
    
    companyListContent = null;
    notScrollableElements = [];
    
    static defaultProps = {
        profilePageActive: false,
        closeProfilePage: function(){},
        handlePasswortReset: function(){},
        remUser: function(){},
        userInfo: null,
        coworkers: null,
        coworkersLimit: null,
        companyTfaPolicy: false,
        UpdateUserRole: function(newVal, userMail){},
        updateCurrentUser: function(){},
        userID: ""
    };

    hasStarted = false;

    constructor(props) {
        super(props);

        this.state = {
            coworkers: this.props.coworkers,
            addingCoworker: false,
            tempName: "",
            tempMail: "",
            tempUserRole: "1",
            tfaInfoActive: false
        };        
    }

    remUser(idx)
    {
        this.props.remUser(idx);
    }

    resetTOTP(email)
    {
        const { t } = this.props;
        Dialog.Alert({
            title: t('ResetTOTP') + " " + email,
            description: t('ResetTOTPSure'),
            options: [
                {label: t('Reset'), className:"dangerConfirm"},
                {label: t('Cancel'), className:""},
            ],
            panelOptions: {className: "vithrough"}
        }).then((optionChosen) => {
            if (optionChosen !== 0) return;
            AdminHandler.ResetTOTP(email, window.config.host.realm)
            .then(() => {
                Dialog.Alert({
                    title: t('ResetTOTP'),
                    description: t('ResetTOTPSuccess'),
                    options: [
                        {label: t('OK'), className:""},
                    ],
                    panelOptions: {className: "vithrough oneButtonDialog"}
                })
            })
            .catch(() => {
                Dialog.Alert({
                    title: t('ResetTOTP'),
                    description: t('ResetTOTPError'),
                    options: [
                        {label: t('OK'), className:""},
                    ],
                    panelOptions: {className: "vithrough oneButtonDialog"}
                })
            })
        });
    }

    componentDidUpdate(prevProps, prevState){
        if (prevProps.coworkers !== this.props.coworkers) {          
          this.setState({coworkers: this.props.coworkers, addingCoworker: false});
        }  
        
        this.updateNotScrollableElements();              
    }

    UpdateTempUserRole(value){
        this.setState({tempUserRole: value});
    }

    componentWillUnmount(){
        if(this.notScrollableElements.length > 0){
            for (let index = 0; index < this.notScrollableElements.length; index++) {
                const element = this.notScrollableElements[index];
                element.removeEventListener('wheel', this.preventScroll, {passive: false})
            }
        }

        if(this.companyListContent){
            this.companyListContent.addEventListener('wheel', this.scrollUsersList);
            this.companyListContent.addEventListener('mousewheel', this.scrollUsersList);
            this.companyListContent.addEventListener('DOMMouseScroll', this.scrollUsersList);
        }
    }

    componentDidMount(){
        this.updateNotScrollableElements();

        this.companyListContent = document.getElementById("company_list_content");
        if(this.companyListContent){
            this.companyListContent.addEventListener('wheel', this.scrollUsersList);
            this.companyListContent.addEventListener('mousewheel', this.scrollUsersList);
            this.companyListContent.addEventListener('DOMMouseScroll', this.scrollUsersList);
        }
    }

    updateNotScrollableElements(){
        this.notScrollableElements = [];
        let notScrollable = document.getElementsByClassName("not_scrollable")

        for (let index = 0; index < notScrollable.length; index++) {
            const element = notScrollable[index];
            this.notScrollableElements.concat(element.getElementsByTagName("*"));
            this.notScrollableElements.push(element);
        }

        if(this.notScrollableElements.length > 0){
            for (let index = 0; index < this.notScrollableElements.length; index++) {
                const element = this.notScrollableElements[index];
                element.addEventListener('wheel', this.preventScroll, {passive: false});
            }
        }
    }
      
    onSave() //NOTE: Seems as this one is currently not being used. May I remove this? - Note from Barbara
    {        
        Dialog.Alert({
            title: "Produkt löschen",
            description: "Wollen Sie das Produkt mit der ID wirklich löschen?",
            options: [
                {label: "LÖSCHEN", className:"positiveConfirm"},
                {label: "Abbrechen", className:"cancel"},
            ]
        })
    }    

    closePage()
    {        
        this.props.closeProfilePage();
        this.setState({addingCoworker: false});
    }

    resetPassword()
    {
        this.props.handlePasswortReset();
    }    
    setAddingCoworker()
    {        
        if (this.state.addingCoworker)
            this.resetInputFields();
        else
            this.setState({addingCoworker: !this.state.addingCoworker});
    }

    addCoworker(){
        const self = this;
        if (this.state.tempName !== "" && this.state.tempMail !== ""){
            AdminHandler.addUser(this.state.tempName, this.state.tempMail, this.state.coworkers[0].UserLocale, this.state.tempUserRole, this.state.coworkers[0].Company, this.props.userInfo[2], this.props.userID)
            .then((res) => {            
              self.resetInputFields();
              self.props.updateCurrentUser();    
            })
            .catch((err) => {
                console.error(err);
                const { t } = this.props;
                if (err.Code == 500)
                {
                    Dialog.Alert({
                        title: t('NewUserCreateErrorTitle'),
                        description: t('EMailError'),
                        options: [
                            {label: "OK", className:""},
                        ],
                        panelOptions: {className: "vithrough oneButtonDialog"}
                    });
                }
                else
                {
                    Dialog.Alert({
                        title: t('LoadError'),
                        description: t('UserLimitError'),
                        options: [
                            {label: "OK", className:""},
                        ],
                        panelOptions: {className: "vithrough oneButtonDialog"}
                    });
                }
            })
        }
    }

    resetInputFields()
    {
        this.setState({addingCoworker: false, tempMail: "", tempName: "", tempUserRole: "1"});
    }


    UpdateUserRole(newVal, userMail)
    {            
      var newUsers = this.state.coworkers;
      var user = newUsers.find((e) => e.UserEmail === userMail);
      var prevRole = user.UserRole;
      user.UserRole = newVal;
      this.setState({coworkers: newUsers});      
      AdminHandler.updateUserRole(newVal, userMail)
      .then((res) => {})
      .catch((err) =>{
        console.error(err);
        user.UserRole = prevRole;
        this.setState({coworkers: newUsers});
      })
    }

    getCoworkerList(){        
        if (this.props.coworkers == null) return;

        var myself = this.props.coworkers.find((w) => w.UserEmail === this.props.userInfo[0]);
        let rows = [];

        if (this.props.coworkers == null) return rows;

        this.props.coworkers.map((coworker,index) => {        
            rows.push(
                <div key={index+1}>
                    <div className='company_worker_existing' title={coworker.UserEmail} style={{display: "flex", flexDirection: "Row"}}>
                        <p style={{width: "55%"}} >{coworker.UserName}</p>
                        {
                            myself != null && myself.UserRole === 1 &&
                            <select title={this.props.t('UserRole')} value={coworker.UserRole} disabled={coworker.UserEmail === myself.UserEmail} onChange={(e) => this.UpdateUserRole(e.target.value, coworker.UserEmail)} type="select" style={{width: "20%"}}>
                                <option value="1">Admin</option>
                                <option value="2">Editor</option>
                                <option value="3">User</option>
                            </select>
                        }
                        {/*<img src={KeyIcon}></img>*/}
                        {
                            myself != null && myself.UserRole === 1 && this.props.companyTfaPolicy == 1 &&
                            <button title={this.props.t('ResetTOTP')} onClick={() => this.resetTOTP(coworker.UserEmail)}><img alt={this.props.t('ResetTOTP')} src={ResetTOTPIcon}></img></button>
                        }
                        {
                            myself != null && myself.UserRole === 1 &&
                            <button title={this.props.t('Delete')} disabled={coworker.UserEmail === myself.UserEmail} onClick={() => this.remUser(index)}><img alt="" src={BinIcon}></img></button>
                        }                                              
                    </div>
                    <span className='border_line'/>                            
                </div>);
            return "";
        }); 

        return rows;       
    }

    focusUsersList(e){
        e.preventDefault();
        let content = document.getElementById('company_list_content');
        if(content){
            content.focus({ focusVisible: false });
        }
    }

    preventScroll(e){
        e.preventDefault();
        e.stopPropagation();
        return false;
    }

    scrollUsersList(e){
        let delta = e.wheelDelta || -e.detail;
        this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
        e.preventDefault();
        e.stopPropagation();
    }

    updateCompanyTfaPolicy(newPolicy)
    {
      const { t } = this.props;
      Dialog.Alert({
          title: t('TFADangerHeader'),
          description: t('TFADangerBody', { '0': this.props.userInfo[2] }),
          options: [
              {label: t('OK'), className:"dangerConfirm"},
              {label: t('Cancel'), className:""},
          ],
          panelOptions: {className: "vithrough"},
      }).then((optionChosen) => {
          if (optionChosen === 0) {
            AdminHandler.updateCompanyTFAPolicy(this.props.coworkers[0]["Company"], newPolicy)
              .then((res) => {
                this.props.updateCurrentUser();
              })
              .catch((err) =>{
                console.error(err);
              })
          }
      })
    }

    render() {
        const coworkers = this.props.coworkers;
        const coworkersLimit = this.props.coworkersLimit;
        const canAddCoworkers = coworkersLimit == null ||  (this.props.coworkers && coworkersLimit > this.props.coworkers.length);
        var myself = (this.state.coworkers != null && this.props.userInfo != null && this.props.userInfo[0] != null) ? this.state.coworkers.find((w) => w.UserEmail === this.props.userInfo[0]) : null;
        var isCompanyAdmin = myself != null ? myself.UserRole < 2 : false;
        const { t } = this.props;
        return (
            <div className={this.props.profilePageActive?'profilePage profilePageActive' : 'profilePage profilePageInactive'}>
                <div style={{margin: "10vh 3vw 0vh 3vw"}}>
                    <div style={{display: "flex", justifyContent: "space-between"}}>
                        <img alt="" src={AccountIcon}></img>
                        <button title={t('Close')} onClick={() => this.closePage()}><img alt={t('Close')} src={CloseIcon}></img></button>
                    </div>
                    <div>
                        <h1>{t('AccountSettings')}</h1>
                    </div>
                    {
                        this.props.userInfo != null &&
                        <div>                        
                        <p className='no_edit'>{this.props.userInfo[1]}</p>
                        <p className='no_edit'>{this.props.userInfo[0]}</p>
                        <p className='no_edit'></p>
                        <p className='no_edit'>{this.props.userInfo[2]}</p>
                        </div>
                    }
                    
                    <div>
                        <button className='passwort_reset' onClick={() => this.resetPassword()} title={t('ResetPassword')}>{t('ResetPassword')}</button>
                    </div>
                    <span className='border_line seperator'/>
                    <div className='tfa_conainer'>
                            <div className='tfa_header'>
                                <div className='tfa_header_left'>
                                    <p>{t('TFAInfoHeader')}</p>
                                    <div className={this.state.tfaInfoActive ? 'infoIcon icon_active' : 'infoIcon'} onClick={() => this.setState({tfaInfoActive: !this.state.tfaInfoActive})}><img alt='' src={infoIcon}></img></div>
                                </div>
                                <div className='tfa_header_right'>
                                    <label className="switch">
                                        <input onChange={(e) => this.updateCompanyTfaPolicy(e.target.checked)} checked={!!this.props.companyTfaPolicy} type="checkbox"></input>
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            {
                                this.state.tfaInfoActive && 
                                <div className='tfa_body'>
                                    {t('TFAInfoBody')}
                                </div>
                            }
                        </div>
                    <div className='company_list_wrapper'>
                        
                        <p className='no_edit'>{t('Coworkers') + " " + (coworkers ? coworkers.length : 0) + "/" + (coworkersLimit ? coworkersLimit : "?")}</p>
                        <div className='company_list'>
                            <div id='company_list_content' onMouseEnter={(e) => this.focusUsersList(e)}>
                            {
                                this.getCoworkerList()                                
                            }
                            </div>
                            <div>
                            {this.state.addingCoworker &&
                                <div className='not_scrollable'>
                                    <div className='company_worker_new' title={t('AddUser')} style={{display: "flex", flexDirection: "Row"}}>
                                        <input placeholder="Name" type='text' value={this.state.tempName} onChange={(e) => this.setState({tempName: e.target.value})} style={{width: "40%"}} ></input>
                                        <input placeholder="E-Mail" type='text' value={this.state.tempMail} onChange={(e) => this.setState({tempMail: e.target.value})}  style={{width: "40%"}} ></input>
                                        <div className='add_worker_dropdown_container'>
                                            <Dropdown className="company_worker_dropdown" value={this.state.tempUserRole ? this.state.tempUserRole : 0} selections={[{text: "Admin", value: 1}, {text: "Editor", value: 2}, {text:"User", value: 3}]} onChange={(value) => this.UpdateTempUserRole(value)}/>
                                        </div>
                                    </div>
                                </div>                                                                                                        
                            }
                            <div className='not_scrollable' style={{display: "flex", flexDirection: "Row", justifySelf: "end", justifyContent: "space-between"}}>
                                {
                                    this.props.coworkers != null && isCompanyAdmin && canAddCoworkers &&
                                    <button className={this.state.addingCoworker ? "add_worker_cancel" : "add_worker"} onClick={() => {if(canAddCoworkers){this.setAddingCoworker()}}} title="Add User">{this.state.addingCoworker ? t('AddCoworkerCancel') : t('AddCoworker')}</button>
                                }
                                {
                                    canAddCoworkers && this.state.addingCoworker &&
                                    <button className={"add_worker"} onClick={() => {if(canAddCoworkers){this.addCoworker()}}}>{t('AddCoworkerConfirm')}</button>
                                }
                            </div>
                            </div>
                        </div>
                    </div>
                    {
                        
                        <div style={{display: "flex", flexDirection: "Row", justifyContent: "flex-end"}}>
                        {
                            //<button className='armodelviewer_button' title="speichen" onClick={() => this.testKeycloakFunctions()}>{TranslatedTexts.Save</button>
                        }
                        </div>
                    }
                </div>
            </div>
        );            
    }
}

export default withTranslation()(ProfilePage);
